import {getDateString} from '../../../../utils';
import {DatePeriod, DateTimePeriod} from '../../types';

export const toDatePeriod = (dateTimePeriod: DateTimePeriod): DatePeriod => ({
  fromDate: getDateString(dateTimePeriod.fromDateTime),
  toDate: getDateString(dateTimePeriod.toDateTime),
});
